const constTerrains = [
    [
    2,
    2,
    5,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    1,
    3,
    1,
    0,
    0,
    1,
    5,
    0,
    0,
    0,
    0,
    0,
    0,
    5,
    2,
    1,
    5,
    1,
    0,
    0,
    5,
    1,
    1,
    0,
    0,
    5,
    0,
    6,
    1,
    1,
    1,
    5,
    5,
    1,
    1,
    2,
    3,
    2,
    0,
    0,
    0,
    1,
    2,
    0,
    0,
    1,
    1,
    1,
    6,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    3,
    3,
    5,
    0,
    0,
    1,
    1,
    0,
    2,
    2,
    1,
    1,
    6,
    6,
    2,
    3,
    4,
    1,
    1,
    1,
    1,
    1,
    5,
    1,
    2,
    1,
    1,
    2,
    1,
    2,
    2,
    4,
    1,
    6,
    2,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    4,
    1,
    2,
    3,
    1,
    1,
    1,
    6,
    2,
    3,
    3,
    2,
    1,
    3,
    4,
    1,
    1,
    3,
    2,
    3,
    3,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    6,
    4,
    2,
    3,
    2,
    3,
    4,
    4,
    4,
    1,
    1,
    1,
    2,
    2,
    2,
    0,
    0,
    1,
    1,
    3,
    4,
    2,
    4,
    4,
    4,
    4,
    4,
    3,
    1,
    4,
    3,
    1,
    1,
    1,
    1,
    1,
    1,
    3,
    3,
    1,
    1,
    1,
    1,
    1,
    2,
    6,
    3,
    3,
    2,
    0,
    0,
    0,
    1,
    3,
    1,
    1,
    1,
    1,
    1,
    3,
    2,
    3,
    1,
    1,
    1,
    1,
    6,
    1,
    2,
    6,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    6,
    6,
    6,
    1,
    1,
    1,
    6
    ],

    [
    1,
    4,
    1,
    1,
    1,
    1,
    1,
    1,
    5,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    1,
    4,
    4,
    1,
    1,
    2,
    2,
    2,
    0,
    0,
    0,
    1,
    1,
    4,
    1,
    3,
    1,
    3,
    1,
    1,
    4,
    3,
    1,
    4,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    3,
    3,
    1,
    2,
    4,
    1,
    1,
    1,
    1,
    1,
    5,
    5,
    1,
    1,
    0,
    1,
    1,
    6,
    1,
    6,
    1,
    1,
    1,
    3,
    4,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    6,
    1,
    6,
    1,
    6,
    1,
    1,
    4,
    4,
    3,
    3,
    6,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    6,
    1,
    1,
    1,
    6,
    6,
    1,
    6,
    4,
    6,
    6,
    2,
    6,
    6,
    1,
    1,
    1,
    6,
    6,
    6,
    6,
    1,
    1,
    1,
    1,
    6,
    2,
    3,
    6,
    1,
    2,
    2,
    3,
    3,
    6,
    6,
    6,
    1,
    1,
    6,
    1,
    1,
    1,
    1,
    6,
    3,
    2,
    3,
    3,
    1,
    3,
    1,
    1,
    5,
    2,
    2,
    2,
    1,
    6,
    1,
    1,
    3,
    1,
    1,
    6,
    6,
    6,
    1,
    1,
    1,
    1,
    3,
    5,
    0,
    2,
    0,
    0,
    6,
    6,
    1,
    1,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    3,
    4,
    4,
    6,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    3,
    3,
    4,
    6,
    3,
    2,
    5,
    5,
    0,
    0,
    0,
    5,
    3,
    1,
    1,
    1,
    1,
    2,
    2,
    1
    ],

    [
    2,
    2,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    4,
    1,
    1,
    1,
    1,
    4,
    2,
    3,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    3,
    3,
    3,
    1,
    1,
    1,
    1,
    2,
    3,
    4,
    5,
    4,
    4,
    2,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    1,
    1,
    3,
    4,
    2,
    3,
    0,
    3,
    4,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    3,
    4,
    2,
    0,
    0,
    0,
    6,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    4,
    4,
    1,
    1,
    1,
    1,
    1,
    4,
    4,
    0,
    0,
    0,
    3,
    6,
    6,
    6,
    6,
    1,
    1,
    1,
    1,
    1,
    3,
    1,
    1,
    1,
    1,
    3,
    5,
    0,
    0,
    4,
    1,
    1,
    1,
    1,
    3,
    6,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    3,
    3,
    5,
    3,
    3,
    1,
    1,
    1,
    1,
    6,
    6,
    1,
    1,
    1,
    1,
    3,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    6,
    1,
    1,
    1,
    3,
    3,
    2,
    3,
    1,
    1,
    1,
    1,
    1,
    3,
    1,
    1,
    2,
    2,
    2,
    1,
    2,
    6,
    6,
    1,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    3,
    4,
    1,
    1,
    2,
    2,
    2,
    1,
    2,
    1,
    2,
    6,
    0,
    5,
    1,
    1,
    2,
    1,
    1,
    1,
    4,
    4,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    5,
    1,
    5,
    5
    ]
];

const uniqueResources = [
    [
        {
            u: 11,
            v: 3,
            resource: 'burial-site'
        },
        {
            u: 4,
            v: 9,
            resource: 'coal'
        },
        {
            u: 2,
            v: 4,
            resource: 'rare-animals'
        },
        /*{
            u: 12,
            v: 9,
            resource: 'gold'
        },*/
        {
            u: 7,
            v: 10,
            resource: 'healing-roots'
        },
        {
            u: 7,
            v: 1,
            resource: 'oil'
        },
        {
            u: 9,
            v: 8,
            resource: 'uranium'
        }
    ],
    [
        {
            u: 16,
            v: 1,
            resource: 'burial-site'
        },
        {
            u: 2,
            v: 5,
            resource: 'coal'
        },
        {
            u: 17,
            v: 10,
            resource: 'rare-animals'
        },
        /*{
            u: 12,
            v: 6,
            resource: 'gold'
        },*/
        {
            u: 5,
            v: 1,
            resource: 'healing-roots'
        },
        {
            u: 10,
            v: 1,
            resource: 'oil'
        },
        {
            u: 2,
            v: 10,
            resource: 'uranium'
        }
    ],
    [
        {
            u: 15,
            v: 6,
            resource: 'burial-site'
        },
        {
            u: 1,
            v: 7,
            resource: 'coal'
        },
        {
            u: 7,
            v: 10,
            resource: 'rare-animals'
        },
        /*{
            u: 7,
            v: 5,
            resource: 'gold'
        },*/
        {
            u: 13,
            v: 3,
            resource: 'healing-roots'
        },
        {
            u: 15,
            v: 11,
            resource: 'oil'
        },
        {
            u: 3,
            v: 2,
            resource: 'uranium'
        }
    ]
];

const constworld = {
    getRandomWorld: () => {
        const index = Math.floor(Math.random()*constTerrains.length*0.9999999);
        return {
            terrain: constTerrains[index],
            uniqueResources: uniqueResources[index]
        };
    }
};

export default constworld;